/**
 * Native bridge communication utilities for iOS/Android.
 */

export const sendMessageToApp = (message) => {
  // iOS
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.reactNative) {
    window.webkit.messageHandlers.reactNative.postMessage(message);
  }
  // Android
  else if (window.android) {
    window.android.postMessage(message);
  }
};

export const sendLinkToApp = (url) => {
  sendMessageToApp("href:" + url);
};
